module.exports = {"Custom Password Reset Email":"Reset Password Notification","Reset Password Notification":"Reset Password Notification"};